import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { BASE_URL, ADMIN_URL } from './constant/BaseApiUrl';

export default class AdminQuoteService {
  getStatistic() {
    return axios.get(`${BASE_URL}${ApiKey.ADMIN_STATISTIC}`);
  }
  getReportStatistic() {
    return axios.get(`${BASE_URL}${ApiKey.ADMIN_REPORT_STATISTIC}`);
  }
  getListQuotes(role, payload) {
    return axios.post(`${BASE_URL}${ApiKey.ADMIN_QUOTE}${role ? '?dept=' + role : ''}`, payload);
  }
  getQuoteDetail(id) {
    return axios.get(`${BASE_URL}${ApiKey.ADMIN_QUOTE_DETAILS}/${id}`);
  }
  updateQuote(payload, sk) {
    return axios.put(`${BASE_URL}${ApiKey.ADMIN_QUOTE_DETAILS}/${sk}`, payload);
  }
  getAirlines() {
    return axios.get(`${ADMIN_URL}airline`);
  }
  getListReportQuotes(payload) {
    return axios.post(`${BASE_URL}${ApiKey.REPORT_QUOTE}`, payload);
  }
  updateQuoteStatus(sk, sts) {
    return axios.put(`${BASE_URL}quotes/${sk}/status?sts=${sts}`);
  }
  updateLangQuote(sk, lang) {
    return axios.put(`${BASE_URL}quotes/language/${sk}/${lang}`);
  }
  updateInternalStatus(sk, sts) {
    return axios.post(`${BASE_URL}${ApiKey.UPDATE_INTERNAL_STATUS}/${sk}/${sts}`);
  }
  getNote(quoteId) {
    return axios.get(`${BASE_URL}${ApiKey.VIEW_QUOTE}${quoteId}${ApiKey.NOTE}`, { params: { isViewed: true } });
  }
  addNote(quoteId, payload) {
    return axios.post(`${BASE_URL}${ApiKey.VIEW_QUOTE}${quoteId}${ApiKey.NOTE}`, payload);
  }

  updateAcknowledgeNote(quoteId: string, payload: any) {
    return axios.put(`${BASE_URL}${ApiKey.VIEW_QUOTE}${quoteId}${ApiKey.NOTE}${ApiKey.ACKNOWLEDGE}`, payload);
  }

  filterNote(quoteId: string, noteType: string, params: any) {
    return axios.get(`${BASE_URL}${ApiKey.VIEW_QUOTE}${quoteId}${ApiKey.NOTE}/${noteType}/${ApiKey.FILTER}`, {
      params: params
    });
  }

  preSigned(imgUrl: string) {
    return axios.post(`${BASE_URL}${ApiKey.FILE}${ApiKey.PRE_SIGNED}`, {
      url: imgUrl
    });
  }

  getListVoucher(payload) {
    return axios.post(`${BASE_URL}${ApiKey.VOUCHER_GET_LIST}`, payload);
  }

  getContractHotel(hCode) {
    return axios.get(`${BASE_URL}${ApiKey.HCMS_ADMIN}/${hCode}`);
  }

  lastVisitStatic() {
    return axios.post(`${BASE_URL}${ApiKey.LAST_VISIT}`);
  }
}
